import { getFileById } from '@/API/repositories/storedDocument';

export const downloadFile = async (file, makeRequest, setLoadingFiles) => {
	const { _id: id, extension, filename, stored_document } = file;
	setLoadingFiles((prev) => [...prev, id ? id : stored_document]);

	const response = await makeRequest(getFileById.bind(null, stored_document));

	if (response.data) {
		const url = window.URL.createObjectURL(
			new Blob([new Uint8Array(response.data.data.data).buffer]),
		);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', (filename && extension) ? `${filename}.${extension}` : response.data.name);
		document.body.appendChild(link);
		link.click();
	}

	setLoadingFiles((prev) => prev.filter((el) => el !== (id ? id : stored_document)));
};
